(function () { if (!LN.Core) throw new Error("LN.Core missing"); })();

(function (Message) {
  'use strict';
  // ==================================================
  // Mensajes de error
  // ==================================================  
  Message.Error = {
    '500': "Internal Server Error",
    '400': "Bad Request",
    '401': "Unauthorized",
    '403': "Forbidden",
    '404': "Not Found",
    '405': "Method Not Allowed",
    'TIMEOUT': "Connection Timeout",
    'ABORT': "Aborted",
    'GENERAL': "Error",
    'ENLACE_CADUCADO': "El link no se encuentra vigente."
  };

  Message.Analytics.Error = {
    '500': "Internal Server Error",
    '400': "Bad Request",
    '401': "Unauthorized",
    '403': "Forbidden",
    '404': "Not Found",
    '405': "Method Not Allowed",
    'TIMEOUT': "Connection Timeout",
    'ABORT': "Aborted",
    'GENERAL': "Error",
    'ENLACE_CADUCADO': "El link no se encuentra vigente."
  };



  // ==================================================
  // Mensajes de error
  // ==================================================  
  Message.Usuario = {
    'CAPTCHA_INVALIDO': 'Captcha inválido',
    'CAPTCHA_REQUERIDO': 'Confirmá el captcha para poder continuar',
    'CAPTCHA_EXPIRADO': 'La verificación ha caducado. Vuelve a marcar la casilla de verificación.',
    'USUARIO_INVALIDO': 'Ingresá un e-mail o un usuario válido',
    'EMAIL_INVALIDO': 'Ingresá un e-mail válido',
    'EMAIL_NO_EXISTE': 'El e-mail no corresponde a una cuenta existente. Verificalo o registrate con una nueva cuenta.',
    'CLAVE_INVALIDA': 'La contraseña que ingresaste es incorrecta',
    'CLAVE_INCORRECTA': 'Contraseña incorrecta. Por favor, ingresala nuevamente',
    'CLAVE_DIFIERE': 'Las contraseñas no coinciden.',
    'CLAVE_FAIL': 'La contraseña es incorrecta.',
    'SUSPENDIDO_POR_ABUSO': 'Tu usuario fue suspendido. Para ingresar creá una cuenta con otro e-mail',
    'ELIMINADO_LOGICO': 'Tu usuario fue eliminado. Para ingresar creá una cuenta con otro e-mail',
    'SUSPENDIDO_DEFINITIVO': 'Suspendido definitivo',
    'USUARIO_EXISTE_MAIL': 'Se produjo un error al enviar el mail al nuevo usuario registrado',
    'USUARIO_EXISTE': 'El Email ya existe',
    'USUARIO_NO_EXISTE': 'El usuario no existe',
    'USUARIO_O_GUID_NO_EXISTE': 'El usuario o GUID no existe',
    'NO_ACTUALIZA': 'No pudimos actualizar tu contraseña, por favor intentá nuevamente',
    'LOGUEATE_RED_SOCIAL': 'El mail ingresado ya se encuentra registrado con Google y Facebook, ingresá utilizando el botón de Google o Facebook.',
    'LOGUEATE_RED_SOCIAL_GOOGLE': 'El mail ingresado ya se encuentra registrado con Google, ingresá utilizando el botón de Google.',
    'LOGUEATE_RED_SOCIAL_FACEBOOK': 'El mail ingresado ya se encuentra registrado con Facebook, ingresá utilizando el botón de Facebook.',
    'NOMBRE_APELLIDO_INCORRECTO': 'Tenés que incluir al menos 2 caracteres sin números ni símbolos',
    'DOMINIO_INVALIDO': 'Dominio no permitido.',
    'FACEBOOK_EXISTE': 'Ya existe un usuario con el perfil de Facebook ingresado.',
    'GMAIL_EXISTE': 'Ya existe un usuario con la cuenta de Google ingresada.',
    'CLAVE_ACTUAL_INVALIDA': 'La clave actual ingresada es incorrecta',
    'CLAVE_ANTERIOR_INVALIDA': 'Su clave anterior es incorrecta',
    'VOLVER_A_INTENTARLO': 'Volver a intentarlo',
    'USUARIO_DOMINIO_INVALIDO': 'El dominio está inhabilitado. Intentá con otro.',
    'USUARIO_CLAVE_REPETIDA': 'La nueva contraseña no puede ser igual a una contraseña utilizada previamente.',
    'USUARIO_CAMPO_FALTANTE': 'Debe completar todos los datos para darse de alta.',
    'ALTA_RED_INVALIDA': 'El usuario ya esta registrado o asociado por redes sociales.',
    'ALTA_MAIL_NO_ENVIO': 'Se produjo un error al enviar el mail al nuevo usuario registrado.',
    'CODIGO_INVALIDO': 'Codigo verificacion invalido.',
    'CARACTER_INVALIDO_MAIL': 'El E-mail no puede contener caracteres especiales.',
    'CARACTER_INVALIDO_PASS_REG': 'Tu contraseña incluye caracteres especiales no permitidos. Intentá nuevamente evitando; acentos, ñ, comillas y otros símbolos.',
    'CARACTER_INVALIDO_PASS_LOG': 'Tu contraseña incluye caracteres no permitidos. Por favor inicia ingresa en Olvidé mi contraseña para modificarla.',
    'LONGITUD_INVALIDO_PASS_LOG': 'La contraseña excede la cantidad de caracteres permitidos (8-20).'
  };

  Message.Analytics.Usuario = {
    'CAPTCHA_INVALIDO': 'Captcha inválido',
    'CAPTCHA_REQUERIDO': 'Confirmá el captcha para poder continuar',
    'CAPTCHA_EXPIRADO': 'La verificación ha caducado. Vuelve a marcar la casilla de verificación.',
    'USUARIO_INVALIDO': 'Ingresá un e-mail o un usuario válido',
    'EMAIL_INVALIDO': 'Ingresá un e-mail válido',
    'EMAIL_NO_EXISTE': 'El e-mail no corresponde a una cuenta existente. Verificalo o registrate con una nueva cuenta.',
    'CLAVE_INVALIDA': 'La contraseña que ingresaste es incorrecta',
    'CLAVE_INCORRECTA': 'Contraseña incorrecta. Por favor, ingresala nuevamente',
    'CLAVE_DIFIERE': 'Las contraseñas no coinciden.',
    'CLAVE_FAIL': 'La contraseña es incorrecta.',
    'SUSPENDIDO_POR_ABUSO': 'Tu usuario fue suspendido. Para ingresar creá una cuenta con otro e-mail',
    'ELIMINADO_LOGICO': 'Tu usuario fue eliminado. Para ingresar creá una cuenta con otro e-mail',
    'SUSPENDIDO_DEFINITIVO': 'Suspendido definitivo',
    'USUARIO_EXISTE_MAIL': 'Se produjo un error al enviar el mail al nuevo usuario registrado',
    'USUARIO_EXISTE': 'Ya existe el email ingresado',
    'USUARIO_NO_EXISTE': 'El usuario no existe',
    'USUARIO_O_GUID_NO_EXISTE': 'El usuario o GUID no existe',
    'NO_ACTUALIZA': 'No pudimos actualizar tu contraseña, por favor intentá nuevamente',
    'LOGUEATE_RED_SOCIAL': 'Email Registrado RedesSociales',
    'LOGUEATE_RED_SOCIAL_GOOGLE': 'Email Registrado Google',
    'LOGUEATE_RED_SOCIAL_FACEBOOK': 'Email Registrado Facebook',
    'NOMBRE_APELLIDO_INCORRECTO': 'Tenés que incluir al menos 2 caracteres sin números ni símbolos',
    'DOMINIO_INVALIDO': 'Dominio no permitido.',
    'FACEBOOK_EXISTE': 'Ya existe un usuario con el perfil de Facebook ingresado.',
    'GMAIL_EXISTE': 'Ya existe un usuario con la cuenta de Google ingresada.',
    'CLAVE_ACTUAL_INVALIDA': 'La clave actual ingresada es incorrecta',
    'CLAVE_ANTERIOR_INVALIDA': 'Su clave anterior es incorrecta',
    'VOLVER_A_INTENTARLO': 'Volver a intentarlo',
    'USUARIO_DOMINIO_INVALIDO': 'El dominio está inhabilitado. Intentá con otro.',
    'USUARIO_CLAVE_REPETIDA': 'La nueva contraseña no puede ser igual a una contraseña utilizada previamente.',
    'USUARIO_CAMPO_FALTANTE': 'Debe completar todos los datos para darse de alta.',
    'ALTA_RED_INVALIDA': 'El usuario ya esta registrado o asociado por redes sociales.',
    'ALTA_MAIL_NO_ENVIO': 'Se produjo un error al enviar el mail al nuevo usuario registrado.',
    'CODIGO_INVALIDO': 'Codigo verificacion invalido.',
    'CARACTER_INVALIDO_MAIL': 'El E-mail no puede contener caracteres especiales.',
    'CARACTER_INVALIDO_PASS_REG': 'Tu contraseña incluye caracteres especiales no permitidos. Intentá nuevamente evitando; acentos, ñ, comillas y otros símbolos.',
    'CARACTER_INVALIDO_PASS_LOG': 'Tu contraseña incluye caracteres no permitidos. Por favor inicia ingresa en Olvidé mi contraseña para modificarla.',
    'LONGITUD_INVALIDO_PASS_LOG': 'La contraseña excede la cantidad de caracteres permitidos (8-20).'
  };



  // ==================================================
  // Mensajes de error
  // ==================================================  
  Message.Credencial = {
    'ERROR_ASOCIAR': 'No se pudo vincular tu tarjeta correctamente.',
    'ERROR_NO_COINCIDEN': 'Los números de DNI y Tarjeta que ingresaste no coinciden.  Cargalos nuevamente. <br> ¿Tenés dudas? Llamanos al 5199-4787 o escribinos desde el exterior a <b>accesodigital@lanacion.com.ar</b> ',
    'ERROR_YA_ASOCIADO': 'La cuenta está creada con el e-mail: <b>{{email}}</b> <br>' +
      'Si es tuya, ingresá con ese e-mail.<br><br>' +
      '¿Tenés dudas? Llamanos al 5199-4787 o escribinos desde el exterior a <b>accesodigital@lanacion.com.ar</b> <br><br>' +
      '<a href="https://goo.gl/K3gZWY" target="_blank">¿cómo desvincular la credencial para usarla en mi nueva cuenta?</a>',
    'DNI_INCOMPLETO': 'Revisá que el número de documento esté completo',
    'INCORRECTA': 'Credencial incorrecta'
  }

  Message.Analytics.Credencial = {
    'ERROR_ASOCIAR': 'No se pudo vincular tu tarjeta correctamente.',
    'ERROR_NO_COINCIDEN': 'DNI_TARJETA_NO_COINCIDEN',
    'ERROR_YA_ASOCIADO': 'ERROR_YA_ASOCIADO',
    'DNI_INCOMPLETO': 'Revisá que el número de documento esté completo',
    'INCORRECTA': 'Credencial incorrecta'
  }

  Message.DefaultErrorMessage = 'Ha ocurrido un error. Por favor, intentá nuevamente.';
  Message.Analytics.DefaultErrorMessage = 'Ha ocurrido un error. Por favor, intentá nuevamente.';

})(LN.Message);


// WEBPACK FOOTER //
// ./Statics/scripts/login/core/message.js